import { Ticket } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminVouchers() {
  return (
    <CollectionAdmin
      path="vouchers"
      title="Bonovi / Popusti"
      icon={Ticket}
      testid="admin-vouchers"
      fields={[
        { key: 'code', label: 'Šifra bona' },
        { key: 'value_eur', label: 'Vrijednost (EUR)', type: 'number' },
        { key: 'recipient_email', label: 'Email primatelja' },
        { key: 'status', label: 'Status (issued/redeemed/expired)' },
        { key: 'expires_at', label: 'Vrijedi do' },
        { key: 'note', label: 'Bilješka', type: 'textarea' },
      ]}
    />
  );
}
